import {useLocation} from "react-router-dom";

const useQuery = () => {
    return new URLSearchParams(useLocation().search);
/*     const params = new URLSearchParams(useLocation().search);
    console.log(useLocation().search);
    params.forEach(param => {
        console.log(param);
    });
    return params; */
}

export default useQuery;